// Swiper component
class SwiperComponent extends HTMLElement {
  connectedCallback() {
    // Parse swiperSettings from data attributes
    this.swiperSettings = {
      ...this.parseSwiperSettings(),
    };

    // Initialize Swiper with settings
    this.swiper = new Swiper(this.querySelector('.js-swiper'), this.swiperSettings);

    // Expose method to check initialization status
    this.isInitialized = () => {
      return this.swiper !== undefined && this.swiper !== null;
    };
  }

  // Helper function to parse swiperSettings from data attributes
  parseSwiperSettings() {
    const settings = {};
    const dataAttributes = this.attributes;
    console.log(dataAttributes, "dataAttributes")
    for (const attribute of dataAttributes) {
      const { name, value } = attribute;
      console.log(value, "value")
      if (name === 'data-swiper-options') {
        Object.assign(settings, JSON.parse(value));
      }
    }
    console.log(settings, "settingssettings")
    return settings;
  }
}

customElements.define('swiper-component', SwiperComponent);